'use client';

import { makeAutoObservable } from 'mobx';
import { UiStore } from '@/stores/ui';
import {
  getLocalStorageValue,
  removeLocalStorageValue,
  setLocalStorageValue,
} from '@/utils/localStorage';

const AI_SIDEBAR_OPEN_KEY = 'ai-sidebar-open';
const AI_SIDEBAR_PROMPT_ID_KEY = 'ai-sidebar-prompt-id';

export class AiSidebarStore {
  public sidebarOpen = false;
  public currentAiPromptId: string | null = null;

  constructor(public readonly uiStore: UiStore) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });

    this.sidebarOpen = getLocalStorageValue(AI_SIDEBAR_OPEN_KEY, 'false') === 'true';
    this.currentAiPromptId = getLocalStorageValue(AI_SIDEBAR_PROMPT_ID_KEY, undefined) ?? null;
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    setLocalStorageValue(AI_SIDEBAR_OPEN_KEY, this.sidebarOpen ? 'true' : 'false');
  }

  setCurrentAiPromptId(aiPromptId: string) {
    this.currentAiPromptId = aiPromptId;
    setLocalStorageValue(AI_SIDEBAR_PROMPT_ID_KEY, aiPromptId);
  }

  clearCurrentAiPromptId() {
    this.currentAiPromptId = null;
    removeLocalStorageValue(AI_SIDEBAR_PROMPT_ID_KEY);
  }
}
